import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  name: {
    default: '',
    editor: 'textbox',
  },
  value: { default: '', editor: 'dropdown', editorOptions: ['', '1', '2', '3'] },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  placeholder: {
    default: 'Choose a colour...',
    editor: 'textbox',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A simple mobile dropdown element with various attributes',
  coreComponent_v3: {
    html: `<div style="padding: 16px;">
  <tag3-mobile-dropdown {{...knobs}} ></tag3-mobile-dropdown>
</div>`,
    js: `var dropdown = document.querySelector("tag3-mobile-dropdown");
dropdown.data = [
  { label: "Choose a colour...", value: "" },
  { label: "Red", value: 1 },
  { label: "Blue", value: 2 },
  { label: "Green", value: 3 },
];`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<div style={{padding: "16px" }}>
  <TagMobileDropDown 
    {{...knobs}} 
    data={[
      { label: "Choose a colour...", value: "" },
      { label: "Red", value: 1 },
      { label: "Blue", value: 2 },
      { label: "Green", value: 3 },
    ]}
  />
</div>`,
    knobs: {
      ...PlaygroundKnobs,
    },
  },
};

const ValidationStory: Story = {
  title: 'With validation',
  description: 'A simple mobile dropdown element with various attributes',
  coreComponent_v3: {
    html: `<div style="padding: 16px;">
  <tag3-validator source-element='.some-input' source-element-value-prop='value' trigger-element-event='focusout' rule='required' error-element='.some-input-error'></tag3-validator>
  <tag3-mobile-dropdown {{...knobs}} class='some-input'></tag3-mobile-dropdown>
  <tag3-validation-alert class='some-input-error' device="mobile">You must enter something</tag3-validation-alert>
</div>
`,
    js: `var dropdown = document.querySelector("tag3-mobile-dropdown");
dropdown.data = [
  { label: "Choose a colour...", value: "" },
  { label: "Red", value: 1 },
  { label: "Blue", value: 2 },
  { label: "Green", value: 3 },
];`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<div style={{padding: "16px" }}>
  <Tag3Validator 
    sourceElement='.some-input' 
    sourceElementValueProp='value' 
    triggerElementEvent='focusout' 
    rule='required' 
    errorElement='.some-input-error' />
  <TagMobileDropDown 
    {{...knobs}} 
    data={[
      { label: "Choose a colour...", value: "" },
      { label: "Red", value: 1 },
      { label: "Blue", value: 2 },
      { label: "Green", value: 3 },
    ]}
    className='some-input'
  />
  <Tag3ValidationAlert className='some-input-error' device="mobile">You must enter something</Tag3ValidationAlert>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
    },
  },
};

export const TagMobileDropDownDocs: Component = {
  type: 'component',
  name: 'mobile-dropdown',
  description: 'Renders a mobile dropdown element. This is for use on a mobile device.',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'dropdownId',
      description: 'The id of the dropdown field',
      type: 'string',
    },
    {
      name: 'name',
      description: 'The name of the field',
      type: 'string',
    },
    {
      name: 'value',
      description: 'The selected value',
      type: 'any',
    },
    {
      name: 'data',
      description: 'The data for the list items in the dropdown',
      type: 'any[]',
    },
    {
      name: 'colourScheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'disabled',
      description: 'Whether the input selection is disabled or not',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'textField',
      description: 'The field in the data object array to use as the option display text',
      type: 'string',
    },
    {
      name: 'valueField',
      description: 'The field in the data object array to use as the option value',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'mobileDropDownValueChange',
      description: 'Triggers when the field value changes',
      parameters: [
        {
          name: 'value',
          description: 'The new value',
          type: 'string',
        },
      ],
    },
  ],
  methods: [],
  stories: [PlaygroundStory, ValidationStory],
};
